export default {
    suppliers: [],
    totalDataRow:0
}
  